import { render, staticRenderFns } from "./EditDay.vue?vue&type=template&id=740d05a4&"
import script from "./EditDay.vue?vue&type=script&lang=js&"
export * from "./EditDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports